
import { Component, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { distinctUntilChanged, tap } from 'rxjs';
import { LanguagesService } from './languages.service';

@Component({
    selector: 'tm-language-select',
    templateUrl: './language-select.component.html',
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TmLanguageSelectComponent),
            multi: true
        },
        LanguagesService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        class: 'tm-language-select'
    }
})
export class TmLanguageSelectComponent implements ControlValueAccessor {
  private _value: string;
  protected isDisabled: boolean;
  protected languages: string[];

  protected get value() {
    return this._value;
  }

  protected set value(value) {
    this._value = value;
    this.onChange(value);
    this.onTouched();
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  protected languageCtrl = new FormControl();

  constructor(private _languageService: LanguagesService) {
    this.languages = this._languageService.availables();

    this.languageCtrl.valueChanges.pipe(
      distinctUntilChanged(),
      tap(value => {
        this.value = value;
      }),
      takeUntilDestroyed()
    ).subscribe();
  }
  
  writeValue(value: string): void {
    this._value = value;
    this.languageCtrl.setValue(this._value, {emitEvent: false});
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }


}
